import { colorsPalettes, colorsSets } from "@similarweb/styles";

import type { KeywordListType } from "./types";

export const TOTAL_KEYWORD_LIST_ID = "@@total@@";

export const TOTAL_KEYWORD_LIST_COLOR = colorsPalettes.carbon[200];
export const OTHER_KEYWORD_LIST_COLOR = colorsSets.c.others;

// Only supported entity types for Demand Analysis
export const AVAILABLE_KEYWORD_LIST_TYPES: KeywordListType[] = ["keywordGroup", "aiTopic"];
